import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem } from '@mui/material';
// components
import { CustomAvatar } from '../../custom-avatar';
import { useSnackbar } from '../../snackbar';
import MenuPopover from '../../menu-popover';
import IconButtonAnimate from '../../animate/IconButtonAnimate';
import UserContext from '../../../context/UserProvider/UserContext';
import logout from '../../logout';
import AvatarEditor from './AvatarEditor';
import { PagePathname } from '../../../routes/paths';
// ----------------------------------------------------------------------

const OPTIONS = [
  {
    label: 'Home',
    linkTo: '/',
    disabled: true,
  },
  {
    label: 'Profil',
    linkTo: PagePathname.profil,
    disabled: false,
  },
  {
    label: 'Settings',
    linkTo: '/',
    disabled: true,
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const { username, email, avatar, avatar_config: avatarConfig } = useContext(UserContext);

  const { enqueueSnackbar } = useSnackbar();

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);
  const [openAvatarEditor, setOpenAvatarEditor] = useState(false);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleLogout = () => {
    try {
      logout();
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  const handleClickItem = (path: string) => {
    handleClosePopover();
    navigate(path);
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <CustomAvatar src={avatar} alt={username} name={username} />
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {username}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem disabled={option.disabled} key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
          <MenuItem
            onClick={() => {
              handleClosePopover();
              setOpenAvatarEditor(true);
            }}
          >
            Avatar ändern
          </MenuItem>
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </MenuPopover>

      <AvatarEditor
        open={openAvatarEditor}
        onClose={() => setOpenAvatarEditor(false)}
        username={username}
        currentAvatar={avatar}
        currentConfig={avatarConfig}
      />
    </>
  );
}
